import React from 'react';
import { connect } from 'react-redux';
import ConnectDealElement from '../linkdeal/ConnectDealElement.jsx';
import ConnectTransportElement from '../linktransport/ConnectTransportElement.jsx';
import { ConnectButton } from '../link/ConnectButton.jsx';
import CompositeProductEdit from '../elements/CompositeProductEdit.jsx';
import PaymentsContainer from '../payments/PaymentsContainer.jsx';
import ProfitLossTab from '../elements/ProfitLossTab';
import Link from '../linkdeal/Link.jsx';
import { List, fromJS } from 'immutable';
import { calculateUnlinkedObject, formatQuantity,
  formatCurrency, formatNumber, formatRange, BOLD_FONT } from '../elements/BaseElement.jsx';
import {
  Col,
  Row,
  Panel,
} from 'react-bootstrap';
import { handleFormChanged } from '@/store/allaround.store.js';
import AvailableSince, { VERSIONS } from '@/util/version';
import ProductInPackingDisplayWrapper from
  '@/component/dict/complex/product/ProductInPackingDisplayWrapper';
import InterestValuesTab from '../elements/InterestValuesTab';
import MultiNodalTab from '../purchaseMultiNodalTab/MultiNodalTab';


export const renderProductLabel = (product) => <Col xs={12} className="deal-payments-tab">
  <span className="text-primary" style={BOLD_FONT}>
                Product:
  </span>
  <ProductInPackingDisplayWrapper
    productTypeId={product.get('productType')}
    packingId={product.get('packing')}
    noBorder
  />
  <span className="text-primary" style={BOLD_FONT}>
                  Quantity:
  </span>
  <span> {formatQuantity(product, true)}</span>
  <span className="text-primary" style={BOLD_FONT}>
                  Price:
  </span>
  <span style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
    {product.get('fixedPrice') !== false &&
      product.get('priceValue') ?
      `${formatCurrency(product.get('priceCurrency'))}
                  ${formatNumber(product.get('priceValue'), '0,0.00')} `
      : ''}
    {product.get('fixedPrice') === false &&
    product.get('priceFormula') ?
      `${product.get('priceFormula', '').substring(0, 140)} ` : ''}
  </span>
  <span className="text-primary" style={BOLD_FONT}>
                  Shipment:
  </span>
  <span style={{ whiteSpace: 'normal' }}>
    {product.get('shipmentFrom') ||
      product.get('shipmentTo') ?
      formatRange(product.get('shipmentFrom'),
        product.get('shipmentTo'))
      : ''}
  </span>
</Col>;

class ProductsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.onDelete = this.onDelete.bind(this);
    this.state = { hidden: false };
  }

  shouldComponentUpdate(props, state) {
    if (!props.product || !this.props.product) {
      return true;
    }
    const newProduct = props.product.toJS();
    const oldProduct = this.props.product.toJS();

    const newPropsClone = JSON.parse(JSON.stringify(props));
    const oldPropsClone = JSON.parse(JSON.stringify(this.props));
    oldPropsClone.product = undefined;
    newPropsClone.product = undefined;

    if (JSON.stringify(state) == JSON.stringify(this.state)
    && JSON.stringify(newPropsClone) == JSON.stringify(oldPropsClone)
    && JSON.stringify(oldProduct) == JSON.stringify(newProduct)) {
      return false;
    }
    return true;
  }

  onDelete() {
    this.setState({ hidden: !this.state.hidden });
  }

  render() {
    const purchaseLinks = this.props.product.get('purchaseLink');
    const saleLinks = this.props.product.get('saleLink');
    let renderLinkButton = !this.props.isArchived && !this.props.dealCanceled;
    renderLinkButton = renderLinkButton && !!(this.props.product.get('product') ||
      this.props.product.get('product') === 0);
    if (this.props.dealType == 'purchase') {
      renderLinkButton = renderLinkButton && Object.values(
        calculateUnlinkedObject(fromJS(this.props.product), purchaseLinks || new List()))
        .filter(k => k > 0).length > 0;
    } else if (this.props.dealType == 'sale') {
      renderLinkButton = renderLinkButton && Object.values(
        calculateUnlinkedObject(fromJS(this.props.product), saleLinks || new List()))
        .filter(k => k > 0).length > 0;
    }
    return (
      <Col
        xs={12}
        className={'product-container'}
        id={`deal_atom_${this.props.idx}`}
        style={this.props.tabSelected != 'deal' && this.props.idx > 0 ? { marginTop: 20 } : {}}
      >
        <Row
          className="row-eq-height"
          name={`productAndLink${this.props.idx}`}
          id={`productAndLink${this.props.idx}`}
          style={!this.state.hidden &&
             this.props.tabSelected == 'deal' ? {} : { display: 'none' }}
        >
          {this.props.dealType == 'purchase' ?
            <Col md={6} xs={12}>
              <Panel
                style={{ height: '100%' }}
                className="composite-product-panel purchase-product"
              >
                <CompositeProductEdit
                  idx={this.props.idx}
                  data={this.props.product}
                  links={purchaseLinks}
                  formId={this.props.idx}
                  deal={this.props.deal}
                  key={this.props.idx}
                  dealType={this.props.dealType}
                  owner="purchase"
                  disabled={this.props.disabled}
                  onDelete={this.onDelete}
                  contractor={this.props.dealType == 'purchase' ?
                    this.props.seller : this.props.buyer}
                />
              </Panel>
            </Col> : ''}
          <Col
            md={6} xs={12} className={`composite-product-links ${this.props.dealType == 'sale' ?
              'sale-links' : 'purchase-links'}`}
          >
            {this.props.product.get(`${this.props.dealType}Link`) ?
              this.props.product.get(`${this.props.dealType}Link`).map((productLink, linkIdx) => (
                <fieldset
                  className="linkForm" id={`link-${linkIdx}`} key={`link-${linkIdx}`}
                >
                  <Link
                    label="Link to composite product"
                    fromType={this.props.dealType}
                    toType={this.props.dealType == 'purchase' ? 'sale' : 'purchase'}
                    defaultValue={productLink}
                    position={this.props.dealType == 'purchase' ? 'right' : 'left'}
                    productIdx={this.props.idx}
                    idx={linkIdx}
                    disabled={this.props.disabled}
                  />
                </fieldset>
              ))
              : ''
            }
            {!this.props.disabled && renderLinkButton ?
              <Row id="linkButtons" className="link-buttons">
                <ConnectButton
                  position={this.props.dealType == 'purchase' ? 'right' : 'left'}
                  connectDeal={<ConnectDealElement
                    productIdx={this.props.idx}
                    startAtomsLinking={this.props.startAtomsLinking}
                  />}
                  connectTransport={
                    <ConnectTransportElement
                      productIdx={this.props.idx}
                      buttonStyle={{ float: this.props.dealType == 'purchase' ? 'right' : '' }}
                      productId={this.props.product.get('product')}
                      transportType={this.props.product.get('transportType')}
                    />
                  }
                />
              </Row>
              : ''
            }
          </Col>
          {this.props.dealType == 'sale' ?
            <Col md={6} xs={12}>
              <Panel
                style={{ height: '100%' }}
                className="composite-product-panel sale-product"
              >
                <CompositeProductEdit
                  idx={this.props.idx}
                  data={this.props.product}
                  links={saleLinks}
                  deal={this.props.deal}
                  formId={this.props.idx}
                  key={this.props.idx}
                  dealType={this.props.dealType}
                  owner="sale"
                  disabled={this.props.disabled}
                  onDelete={this.onDelete}
                  contractor={this.props.dealType == 'purchase' ?
                    this.props.seller : this.props.buyer}
                />
              </Panel>
            </Col> : ''}
        </Row>
        <Row
          className="row-eq-height"
          name={`productAndLink${this.props.idx}`}
          id={`productAndLink${this.props.idx}`}
          style={!this.state.hidden && this.props.tabSelected == 'payments' ?
            {} : { display: 'none' }}
        >
          <AvailableSince version={VERSIONS.Iphito}>
            <div style={{ width: '100%' }}>
              {renderProductLabel(this.props.product)}
              {this.props.tabSelected == 'payments' && this.props.dealType == 'purchase' &&
                <Col xs={12}>
                  <InterestValuesTab
                    productIdx={this.props.idx} disabled={this.props.disabled}
                  />
                  <br />
                </Col>
              }
              <PaymentsContainer
                productIdx={this.props.idx} contractNumber={this.props.contractNumber}
                contractDate={this.props.contractDate}
                dealType={this.props.dealType}
                producers={this.props.producers}
                disabled={this.props.disabled}
                producersSelected={this.props.producers}
                contractor={this.props.dealType == 'purchase' ?
                  this.props.seller : this.props.buyer}
                product={this.props.product}
              />
            </div>
          </AvailableSince>
        </Row>
        {this.props.tabSelected == 'PL' &&
          <Row
            className="row-eq-height"
            name={`productAndLink${this.props.idx}`}
            id={`productAndLink${this.props.idx}`}
            style={!this.state.hidden ?
              {} : { display: 'none' }}
          >
            <div style={{ width: '100%' }}>
              {renderProductLabel(this.props.product)}
              <ProfitLossTab
                id={this.props.product.get('id')}
                showGrandTotal={this.props.isLast}
              />
            </div>
          </Row>
        }
        {this.props.tabSelected == 'Multinodal' &&
          <Row
            className="row-eq-height"
            name={`productAndLink${this.props.idx}`}
            id={`productAndLink${this.props.idx}`}
            style={!this.state.hidden ?
              {} : { display: 'none' }}
          >
            <div style={{ width: '100%' }}>
              {renderProductLabel(this.props.product)}
              <MultiNodalTab
                disabled={this.props.disabled}
                startAtomsLinking={this.props.startAtomsLinking}
                productIdx={this.props.idx}
              />
            </div>
          </Row>
        }
      </Col>
    );
  }
}

ProductsContainer.propTypes = {
  product: React.PropTypes.object,
  isArchived: React.PropTypes.bool,
  dealType: React.PropTypes.string,
  idx: React.PropTypes.number,
  disabled: React.PropTypes.bool,
  startAtomsLinking: React.PropTypes.func,
  contractNumber: React.PropTypes.string,
  contractDate: React.PropTypes.string,
  seller: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
  buyer: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
  producers: React.PropTypes.object,
  mode: React.PropTypes.string,
  tabSelected: React.PropTypes.bool,
  dealCanceled: React.PropTypes.bool,
  deal: React.PropTypes.object,
  isLast: React.PropTypes.bool,
};
export default connect((state, props) => ({
  product: state.getIn(['data', 'deals', 'deal', 'products', props.idx]),
  contractNumber: state.getIn(['data', 'deals', 'deal', 'regNumber'], ''),
  buyer: state.getIn(['data', 'deals', 'deal', 'buyer']),
  seller: state.getIn(['data', 'deals', 'deal', 'supplier']),
  producers: state.getIn(['data', 'deals', 'deal', 'producers'], new List()),
  isArchived: state.getIn(['data', 'deals', 'deal', 'isArchived']),
  dealCanceled: state.getIn(['data', 'deals', 'deal', 'dealCanceled']),
  formChanged: state.getIn(['allaround', 'formChanged']),
}), (dispatch) => ({
  handleFormChanged() {
    handleFormChanged(dispatch);
  } }))(ProductsContainer);
